<template>
  <div class="my-table userPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('editTask.txt1')}}</span>
        <span>{{$t('editTask.txt2')}} / {{$t('editTask.txt3')}} / {{$t('editTask.txt4')}}</span>
      </div>
      <div class="flexEnd">
        <div class="searchBtn ml20" @click="onBack">{{$t('editTask.txt5')}}</div>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="tableCard p30">
      <div class="contactTitle flexCenter mb50">
        <span>{{$t('editTask.txt4')}}</span>
        <div class="flexEnd">
          <div class="onCancelBtn mr30" @click="onBack">{{$t('editTask.txt6')}}</div>
          <div class="searchBtn" @click="handleRun('addUserForm')">{{$t('editTask.txt7')}}</div>
        </div>
      </div>
      <div class="editForm">
        <el-form :model="addUserForm" :rules="addUserRules" ref="addUserForm" label-width="100px" class="demo-ruleForm">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('editTask.txt8')" prop="jobName">
                <el-input :placeholder="$t('editTask.txt9')" v-model="addUserForm.jobName" @input="change($event)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('editTask.txt10')" prop="queueName">
                <el-select v-model="addUserForm.queueName" :placeholder="$t('editTask.txt11')">
                  <el-option
                  v-for="(item,index) in queueList"
                  :key="index"
                  :label="item.queueName"
                  :value="item.queueName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item :label="$t('editTask.txt12')" prop="context">
              <div class="flex">
                <el-input type="textarea" :rows="25" v-model="addUserForm.context"></el-input>
              <el-upload
            :headers="importHeaders"
            class="avatar-uploader ml20"
            :data="uploadParam"
            :action="uploadAction"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :on-exceed="handleAvatarExceed"
            :on-success="handleAvatarSuccess">
            <el-button class="handlebtnTxt">{{$t('editTask.txt13')}}</el-button>
          </el-upload>
              </div>
            </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</el-card>


</div>
</template>

<script>
  let mytoken = window.sessionStorage.getItem("token");
  import {apiUrl, serverUrl} from '@/utils/request';
  import qs from 'qs';
  export default {
    data() {
      let userInfo = JSON.parse(localStorage.userInfo)
      let uploadPath = userInfo.homePath.replace('/home/', '');
      return {
        importHeaders: {'Authorization': mytoken},
        uploadAction: apiUrl + '/job/upload',
        uploadParam:{path: uploadPath},
        addUserForm:{
          context:'',
          queueList:[],//获取所有队列
        },
        queueList:[],//获取所有队列
        dirsList:[],//目录列表
        // 添加用户规则
        addUserRules: {
          jobName: [
          { required: true, message: this.$t('editTask.txt14'), trigger: 'blur' },
          { pattern: /^[a-zA-Z]{1}\w*$/, message: this.$t('editTask.txt15') },
          ],
          context:[
          { required: true, message: this.$t('editTask.txt16'), trigger: 'change' },
          ],
        },
      };
    },
    created() {
      this.getAllQueue();
      let loginName = window.sessionStorage.getItem("loginName");
      this.getDirs(loginName);
    },
    methods: {
      onBack(){
        this.$router.go(-1);
      },
      // 队列列表
      async getAllQueue() {
        const {data: res} = await this.$http.post("/calculation/queue/list");
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.queueList = res.result;
      },
      change(e){
        this.$forceUpdate()
      },
      // 运行作业
      handleRun(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.runJob();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 运行作业
      async runJob(){
        let data = {
          jobName: this.addUserForm.jobName,
          queueName:this.addUserForm.queueName,
          scriptContent:this.addUserForm.context
        }
        // if(this.selectPath.fileType !== 'sh') {
        //   this.$message.warning('请选择.sh脚本运行')
        //   return false;
        // }
        const {data: res} = await this.$http.post("/job/run",data);
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.$message({
          type: 'success',
          message: this.$t('editTask.txt17')
        });
        this.onBack();
      },
      beforeUpload(file) {
        let name = file.name.replace('.sh', '');
        this.addUserForm.jobName = name;
        return true
      },
      handleAvatarExceed(files, fileList) {
        this.$message.warning(this.$t('editTask.txt18')+files.length);
      },
      handleAvatarSuccess(res, file) {
        if(!res.success){
          return this.$message.error(res.message);
        }
        this.$message({
          type: 'success',
          message: this.$t('editTask.txt19')
        });
        this.addUserForm.context = res.message;
        this.getDirs()
      },
      // 目录列表
      async getDirs(path) {
        const { currentPath } = this
        this.loading = true
        const {data: res} = await this.$http.post("/job/dirs?path=" + currentPath);
        this.loading = false
        if (!res.success) {
          return this.$message.error(res.message);
        }
        let list = [];
        res.result && res.result.forEach(item => {
          item.localPath = item.path.replace(new RegExp('^' + currentPath + '/'), '')
          if(!item.directory) {
            item.fileType = this.getFileType(item.path)
          }
          list.push(item)
        })
        this.dirsList = list || [];
      },
      // 保存作业
      handleSave(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // if(!this.selectPath) {
            //   this.$message.warning('请选择目录')
            //   return
            // }
            this.saveJob();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleUpload(){
        // 语言包todo
        let text = this.load("文件名.txt");
      },
      // 保存作业
      async saveJob(){
        let data = {
          context: this.addUserForm.context,
          createTime: 0,
          id: "",
          jobName: this.addUserForm.jobName,
          path: this.currentPath,
          state: 0
        }
        const {data: res} = await this.$http.post("/job/save",data);
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.$message({
          type: 'success',
          message: this.$t('editTask.txt21')
        });
        this.getDirs()
      }
    }
  };
</script>

<style lang="less" scoped>

  .handleBtn{
    padding: 0;
  }
  .userPage{
    /deep/ .el-upload__input{
      display: none !important;
    }
    .flex{
      display: flex;
    }
    .ml20{
      margin-left: 20px;
    }
    /deep/ .el-date-editor .el-range-separator{
      margin-top: -5px;
      width: 8%;
    }
    .contactTitle{
      margin-bottom: 40px;
    }
    .contactTitle span{
      margin-right: 30px;
      cursor: pointer;
      font-size: 30px;
      font-weight: 500;
      color: #222222;
    }
    .w350{
      width: 350px;
    }
    .searchUserBox{
      /*width: 33.6rem !important;*/
      height: 3.2rem;
      margin-bottom: 3rem;
      /deep/ .el-input__inner{
        border:1px solid #C0C0C0;
        border-right:none;
      }
      /deep/ .el-input-group__append{
        border:1px solid #C0C0C0;
        border-left:none;
        padding:0;
        background: #fff;
      }
      /deep/ .el-input-group__append button.el-button{
        padding:0;
        width: auto;
        margin-right: 1.1rem;
      }
    }
    /deep/ .el-transfer__button:first-of-type{
      display: none;
    }
    /deep/ .el-button--primary{
      width: auto;
      height: auto;
      padding:0;
      background: none;
    }
    /deep/ .el-button--primary.is-disabled{
      background: none;
      border: none;
    }
    .tips{      
      font-size: 1.4rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #98B9FF;
      margin-top: -10px;
    }
    .editForm{}
    /deep/  .el-date-table td.today span{
      color: #fff;
      background: #1B3B7C;
      border-radius: 100%;
    }
    /deep/ .el-date-table td.end-date span,/deep/ .el-date-table td.start-date span{
      background: #1B3B7C !important;
    }
    .handlebtnTxt{
      width: 88px;
      height: 36px;
      border-radius: 18px;
      border: 1px solid #1B3B7C;
      font-size: 14px;
      color: #1B3B7C;
      text-align: center;
      padding: 0;
      line-height: 36px;
    }
  }

</style>
